import { createFileRoute } from '@tanstack/react-router'
import { Microscope } from 'lucide-react'
import { z } from 'zod'
import { RootCauseScreen } from '@/screens/investigate/SCR-021-root-cause'

export const Route = createFileRoute('/_app/w/$ws/root-cause')({
  staticData: { screen: { id: 'SCR-021', title: 'Root cause workbench', group: 'Investigate', perm: 'trace.read', order: 4, description: 'Find why an answer went wrong, and test a fix before you make it.', icon: Microscope } },
  validateSearch: z.object({ manifest: z.string().max(200).optional() }),
  component: RootCauseScreen,
})
